import { get, post, put, Delete } from "../axios";

// 内容分类-列表
export const contentClassifyList = (params) =>
  get("/web/content/classify/list", params);

// 内容分类-新增
export const contentClassifyAdd = (params) =>
  post("/web/content/classify/add", params);

// 内容分类-编辑
export const contentClassifyUpdate = (params) =>
  put("/web/content/classify/update", params);

// 内容分类-删除
export const contentClassifyDelete = (id) =>
  Delete("/web/content/classify/delete/" + id, "");
